<div
  *ngIf="user?.email"
  class="gw-min-h-screen gw-flex gw-flex-col gw-bg-background-base"
>
  <div class="gw-flex gw-justify-end gw-p-medium">
    <app-language-selector></app-language-selector>
  </div>

  <div class="gw-flex gw-flex-1 gw-items-center gw-justify-center gw-p-medium">
    <div
      class="gw-w-full gw-max-w-[420px] gw-bg-background-elevation-2 gw-border gw-border-border-normal gw-rounded-2xl gw-shadow-lg gw-overflow-hidden gw-p-2x-large"
    >
      <h2
        class="gw-text-lg gw-font-semibold gw-text-text-primary gw-mb-2x-large"
      >
        {{ 'features.passwordReset.page.title' | translate }}
      </h2>

      <form
        [formGroup]="signupForm"
        (ngSubmit)="onSubmit()"
        class="gw-flex gw-flex-col gw-gap-2x-large"
      >
        <div class="gw-relative">
          <gatewee-input-v2
            id="password-reset-password"
            [type]="hide_show ? 'text' : 'password'"
            [form]="signupForm"
            controlName="password"
            [label]="'features.passwordReset.form.labels.password' | translate"
            [placeholder]="
              'features.passwordReset.form.placeholders.password' | translate
            "
            [required]="true"
          ></gatewee-input-v2>
          <button
            type="button"
            (click)="passwordHide()"
            class="gw-absolute gw-right-small gw-top-[38px] gw-flex gw-items-center gw-justify-center gw-w-9 gw-h-9 gw-rounded-lg gw-text-text-secondary hover:gw-bg-background-elevation-1 hover:gw-text-text-primary"
            [attr.aria-label]="hide_show ? 'Hide password' : 'Show password'"
          >
            <gatewee-icon
              [icon]="hide_show ? '@phi.eye-slash' : '@phi.eye'"
              size="18px"
            ></gatewee-icon>
          </button>
        </div>

        <gatewee-button
          variant="primary"
          [title]="'features.passwordReset.form.submitButton' | translate"
          type="submit"
          class="gw-w-full"
          [disabled]="signupForm.invalid"
        ></gatewee-button>
      </form>
    </div>
  </div>

  <app-links></app-links>
</div>
